import { number, object, string, url } from 'zod/v4';

const clientEnvSchema = object({
	NEXT_PUBLIC_APP_PROTOCOL: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_PROTOCOL is required.' : 'NEXT_PUBLIC_APP_PROTOCOL must be a string'),
	}),
	NEXT_PUBLIC_APP_DOMAIN: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_DOMAIN is required.' : 'NEXT_PUBLIC_APP_DOMAIN must be a string'),
	}),
	NEXT_PUBLIC_APP_PORT: number().optional(),

	NEXT_PUBLIC_BACKEND_PROTOCOL: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_BACKEND_PROTOCOL is required.' : 'NEXT_PUBLIC_BACKEND_PROTOCOL must be a string'),
	}),
	NEXT_PUBLIC_BACKEND_DOMAIN: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_BACKEND_DOMAIN is required.' : 'NEXT_PUBLIC_BACKEND_DOMAIN must be a string'),
	}),
	NEXT_PUBLIC_BACKEND_PORT: number().optional(),

	NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS: number({
		error: (issue) =>
			issue.input === undefined ? 'NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS is required.' : 'NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS must be a number',
	}),

	NEXT_PUBLIC_API_SOURCE: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_API_SOURCE is required.' : 'NEXT_PUBLIC_API_SOURCE must be a string'),
	}),

	NEXT_PUBLIC_COOKIE_SESSION_ID: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_COOKIE_SESSION_ID is required.' : 'NEXT_PUBLIC_COOKIE_SESSION_ID must be a string'),
	}),
	NEXT_PUBLIC_SKIPPED_TUTORIAL_KEY: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_SKIPPED_TUTORIAL_KEY is required.' : 'NEXT_PUBLIC_SKIPPED_TUTORIAL_KEY must be a string'),
	}),

	NEXT_PUBLIC_APP_NAME: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_NAME is required.' : 'NEXT_PUBLIC_APP_NAME must be a string'),
	}),
	NEXT_PUBLIC_APP_SHORT_NAME: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_SHORT_NAME is required.' : 'NEXT_PUBLIC_APP_SHORT_NAME must be a string'),
	}),
	NEXT_PUBLIC_APP_DESCRIPTION: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_DESCRIPTION is required.' : 'NEXT_PUBLIC_APP_DESCRIPTION must be a string'),
	}),
	NEXT_PUBLIC_APP_KEYWORDS: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_KEYWORDS is required.' : 'NEXT_PUBLIC_APP_KEYWORDS must be a string'),
	}),
	NEXT_PUBLIC_APP_CREATOR: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_APP_CREATOR is required.' : 'NEXT_PUBLIC_APP_CREATOR must be a string'),
	}),
	NEXT_PUBLIC_THEME_COLOR: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_THEME_COLOR is required.' : 'NEXT_PUBLIC_THEME_COLOR must be a string'),
	}),
	NEXT_PUBLIC_BG_COLOR: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_BG_COLOR is required.' : 'NEXT_PUBLIC_BG_COLOR must be a string'),
	}),

	NEXT_PUBLIC_VIACEP_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_VIACEP_URL is required' : 'NEXT_PUBLIC_VIACEP_URL must be a valid url'),
	}),

	NEXT_PUBLIC_USER_PROFILE_PATH: string({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_USER_PROFILE_PATH is required' : 'NEXT_PUBLIC_USER_PROFILE_PATH must be a string'),
	}),
	NEXT_PUBLIC_BLOG_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_BLOG_URL is required' : 'NEXT_PUBLIC_BLOG_URL must be a valid url'),
	}),
	NEXT_PUBLIC_MAIN_WEB_SITE_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_MAIN_WEB_SITE_URL is required' : 'NEXT_PUBLIC_MAIN_WEB_SITE_URL must be a valid url'),
	}),
	NEXT_PUBLIC_INSTALLATION_MASTERS_URL: url({
		error: (issue) =>
			issue.input === undefined ? 'NEXT_PUBLIC_INSTALLATION_MASTERS_URL is required' : 'NEXT_PUBLIC_INSTALLATION_MASTERS_URL must be a valid url',
	}),
	NEXT_PUBLIC_YOUTUBE_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_YOUTUBE_URL is required' : 'NEXT_PUBLIC_YOUTUBE_URL must be a valid url'),
	}),
	NEXT_PUBLIC_INSTAGRAM_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_INSTAGRAM_URL is required' : 'NEXT_PUBLIC_INSTAGRAM_URL must be a valid url'),
	}),
	NEXT_PUBLIC_TIKTOK_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_TIKTOK_URL is required' : 'NEXT_PUBLIC_TIKTOK_URL must be a valid url'),
	}),
	NEXT_PUBLIC_PINTEREST_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_PINTEREST_URL is required' : 'NEXT_PUBLIC_PINTEREST_URL must be a valid url'),
	}),
	NEXT_PUBLIC_LINKEDIN_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_LINKEDIN_URL is required' : 'NEXT_PUBLIC_LINKEDIN_URL must be a valid url'),
	}),
	NEXT_PUBLIC_SUPPORT_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_SUPPORT_URL is required' : 'NEXT_PUBLIC_SUPPORT_URL must be a valid url'),
	}),
	NEXT_PUBLIC_WHO_WE_ARE_URL: url({
		error: (issue) => (issue.input === undefined ? 'NEXT_PUBLIC_WHO_WE_ARE_URL is required' : 'NEXT_PUBLIC_WHO_WE_ARE_URL must be a valid url'),
	}),
	NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL: url({
		error: (issue) =>
			issue.input === undefined ? 'NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL is required' : 'NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL must be a valid url',
	}),
});

const rawClientEnv = {
	NEXT_PUBLIC_APP_PROTOCOL: process.env.NEXT_PUBLIC_APP_PROTOCOL,
	NEXT_PUBLIC_APP_DOMAIN: process.env.NEXT_PUBLIC_APP_DOMAIN,
	NEXT_PUBLIC_APP_PORT: Number(process.env.NEXT_PUBLIC_APP_PORT),

	NEXT_PUBLIC_BACKEND_PROTOCOL: process.env.NEXT_PUBLIC_BACKEND_PROTOCOL,
	NEXT_PUBLIC_BACKEND_DOMAIN: process.env.NEXT_PUBLIC_BACKEND_DOMAIN,
	NEXT_PUBLIC_BACKEND_PORT: Number(process.env.NEXT_PUBLIC_BACKEND_PORT),

	NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS: Number(process.env.NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS),

	NEXT_PUBLIC_API_SOURCE: process.env.NEXT_PUBLIC_API_SOURCE,

	NEXT_PUBLIC_COOKIE_SESSION_ID: process.env.NEXT_PUBLIC_COOKIE_SESSION_ID,
	NEXT_PUBLIC_SKIPPED_TUTORIAL_KEY: process.env.NEXT_PUBLIC_SKIPPED_TUTORIAL_KEY,

	NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
	NEXT_PUBLIC_APP_SHORT_NAME: process.env.NEXT_PUBLIC_APP_SHORT_NAME,
	NEXT_PUBLIC_APP_DESCRIPTION: process.env.NEXT_PUBLIC_APP_DESCRIPTION,
	NEXT_PUBLIC_APP_KEYWORDS: process.env.NEXT_PUBLIC_APP_KEYWORDS,
	NEXT_PUBLIC_APP_CREATOR: process.env.NEXT_PUBLIC_APP_CREATOR,
	NEXT_PUBLIC_THEME_COLOR: process.env.NEXT_PUBLIC_THEME_COLOR,
	NEXT_PUBLIC_BG_COLOR: process.env.NEXT_PUBLIC_BG_COLOR,

	NEXT_PUBLIC_VIACEP_URL: process.env.NEXT_PUBLIC_VIACEP_URL,

	NEXT_PUBLIC_USER_PROFILE_PATH: process.env.NEXT_PUBLIC_USER_PROFILE_PATH,
	NEXT_PUBLIC_BLOG_URL: process.env.NEXT_PUBLIC_BLOG_URL,
	NEXT_PUBLIC_MAIN_WEB_SITE_URL: process.env.NEXT_PUBLIC_MAIN_WEB_SITE_URL,
	NEXT_PUBLIC_INSTALLATION_MASTERS_URL: process.env.NEXT_PUBLIC_INSTALLATION_MASTERS_URL,
	NEXT_PUBLIC_YOUTUBE_URL: process.env.NEXT_PUBLIC_YOUTUBE_URL,
	NEXT_PUBLIC_INSTAGRAM_URL: process.env.NEXT_PUBLIC_INSTAGRAM_URL,
	NEXT_PUBLIC_TIKTOK_URL: process.env.NEXT_PUBLIC_TIKTOK_URL,
	NEXT_PUBLIC_PINTEREST_URL: process.env.NEXT_PUBLIC_PINTEREST_URL,
	NEXT_PUBLIC_LINKEDIN_URL: process.env.NEXT_PUBLIC_LINKEDIN_URL,
	NEXT_PUBLIC_SUPPORT_URL: process.env.NEXT_PUBLIC_SUPPORT_URL,
	NEXT_PUBLIC_WHO_WE_ARE_URL: process.env.NEXT_PUBLIC_WHO_WE_ARE_URL,
	NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL: process.env.NEXT_PUBLIC_BLOCKS_BY_GABSTER_URL,
};

export const env = clientEnvSchema.parse(rawClientEnv);

const withPort = (protocol: string, domain: string, port?: number) => {
	const resolvedPort = port && port > 0 ? port : undefined;
	if (!resolvedPort) {
		return `${protocol}://${domain}`;
	}

	const pathIndex = domain.indexOf('/');
	if (pathIndex === -1) {
		return `${protocol}://${domain}:${resolvedPort}`;
	}

	return `${protocol}://${domain.slice(0, pathIndex)}:${resolvedPort}${domain.slice(pathIndex)}`;
};

export const app_url = withPort(env.NEXT_PUBLIC_APP_PROTOCOL, env.NEXT_PUBLIC_APP_DOMAIN, env.NEXT_PUBLIC_APP_PORT);
export const backend_url = withPort(env.NEXT_PUBLIC_BACKEND_PROTOCOL, env.NEXT_PUBLIC_BACKEND_DOMAIN, env.NEXT_PUBLIC_BACKEND_PORT);

export const APP_METADATA = {
	name: env.NEXT_PUBLIC_APP_NAME,
	shortName: env.NEXT_PUBLIC_APP_SHORT_NAME,
	description: env.NEXT_PUBLIC_APP_DESCRIPTION,
	keywords: env.NEXT_PUBLIC_APP_KEYWORDS.split(','),
	creator: env.NEXT_PUBLIC_APP_CREATOR,
	themeColor: env.NEXT_PUBLIC_THEME_COLOR,
	backgroundColor: env.NEXT_PUBLIC_BG_COLOR,
};
